import { FormEvent } from 'react';
import TextInput from './TextInput';
import IconButton from './IconButton';
import style from './SearchForm.module.css';
import { translate } from '../../../helpers/translations';
import { useTabletOrLarger } from '../../../hooks/responsive';

interface SearchFormPropsInterface {
  term: string;
  onSubmit: (searchTerm: string) => void;
  onSearchTermChanged: (searchTerm: string) => void;
  loading: boolean;
}

export default function SearchForm(props: SearchFormPropsInterface) {
  const {
    term,
    onSubmit,
    onSearchTermChanged,
    loading,

  } = props;

  const handleNotify = (searchTerm: string) => {
    if (searchTerm.length > 1) {
      onSubmit(searchTerm);
    } else {
      onSubmit('');
    }
  };

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    handleNotify(term);
  };

  const handleChange = (searchTerm: string) => {
    onSearchTermChanged(searchTerm);
    handleNotify(searchTerm);
  };

  const isTabletOrLarger = useTabletOrLarger();

  return (
    <form
      className={style.container}
      onSubmit={handleSubmit}
    >
      <TextInput
        type="text"
        name="trade-in-search"
        value={term}
        placeholder={translate(isTabletOrLarger ? 'LYT_SECONDHAND_SEARCH_PLACEHOLDER' : 'LYT_SECONDHAND_SEARCH_PLACEHOLDER_MOBILE')}
        onChange={handleChange}
      />
      <IconButton
        type="submit"
        icon="search"
        disabled={loading}
        label={translate('LYT_SEARCH_BOX_PLACEHOLDER_MOBILE')}
      />
    </form>
  );
}
